import React, { useCallback, useEffect, useState } from 'react'
import AInvbasicDetail from './AInvbasicDetail'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { addInvoiceApi, getInvoiceNumberApi, } from '../apiService'
import { globalGetService, globalPostService } from '../../../utils/globalApiServices'
import { checkApiStatus, normalizeTaxRate } from '../../../utils'
import { useSnackbar } from 'notistack'
import { PageLoader, shouldHideItemDescription, titanAviationIntance } from '../../../shared_elements'
import moment from 'moment'
import { setFileUploadDetails, setUploadFiles } from '../../../shared_elements/actions'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { trackActivity } from '../../../utils/mixpanel'
import { fieldDateFormat } from '../../../constants'
import { getAdditionalTax, getTotalTax } from '..'
import { getInvoiceDialogWidthProps } from './AInvItems'

const AddLinkedInv = ({ onToggleModal, toggleInvModel, modeType, item, addEditInvoice, getResponseBack ,from }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [linkedInv, setLinkedInv] = useState(addEditInvoice?.data);
	const { enqueueSnackbar } = useSnackbar();
	const [tableErrors, setTableErrors] = useState({});
	const [isLoading, setLoading] = useState(false);
	const [attachments, setAttachments] = useState([]);
	const [error, setError] = useState({});
	const [invoiceNumberLoading, setInvoiceNumberLoading] = useState(true);
	const [activeTaxList, setActiveTaxList] = useState([]);

	  useEffect(() => {
		let cancelled = false;
		globalGetService(getInvoiceNumberApi({ lease_slug: linkedInv?.lease_slug, asset_id: linkedInv?.asset?.id, asset_type: linkedInv?.asset?.asset_type, invoice_type: linkedInv?.invoice_type?.value, parent_invoice_type : linkedInv?.parent_invoice_type }))
		  .then((response) => {
			if (!cancelled) {
				if (checkApiStatus(response)) {
					setLinkedInv((prev) => ({ ...prev, invoice_number: response?.data?.data?.invoice_number, lease_end_date: response?.data?.data?.lease_end_date, lease_start_date: response?.data?.data?.lease_start_date }));
				}
				setInvoiceNumberLoading(false);
			}
		  })
		  .catch(() => { if (!cancelled) setInvoiceNumberLoading(false); });
		return () => { cancelled = true; };
	  }, []);
	  
	const onAddEditInvoice = () => {
		let validationInputs = {
			invoice_number: linkedInv?.invoice_number?.trim()?.length ? '' : 'Please enter Invoice Number',
			date: linkedInv?.date ? '' : 'Please enter Invoice Date',
			due_date: linkedInv?.due_date ? '' : 'Please enter Due Date',
			start_date: linkedInv?.start_date ? '' : 'Please enter Period Start Date',
			end_date: linkedInv?.end_date ? '' : 'Please enter Period End Date',
		}

		const invoiceDate = moment(linkedInv?.date);
		const dueDate = moment(linkedInv?.due_date);
		const validationdate = moment(linkedInv?.date_validation)
		if (linkedInv?.date && linkedInv?.due_date) {
			if (dueDate.isBefore(invoiceDate)) {
				validationInputs.due_date = "Due Date cannot be before Invoice Date";
			}
			if (invoiceDate.isAfter(dueDate)) {
				validationInputs.date = "Invoice Date cannot be after Due Date";
			}
			if (invoiceDate.isBefore(validationdate)) {
				validationInputs.date = `Invoice Date cannot be before Parent Invoice Date (${validationdate.format("DD-MM-YYYY").toUpperCase()})`;
			}
			if (linkedInv?.lease_end_date) {
				const maxAllowedDate = moment(linkedInv.lease_end_date).add(3, 'months');
				if (invoiceDate.isAfter(maxAllowedDate)) {
					validationInputs.date = `Invoice Date must be within 3 months after the Lease End Date (${moment(linkedInv.lease_end_date).format(fieldDateFormat)})`;
				}
				if (dueDate.isAfter(maxAllowedDate)) {
					validationInputs.due_date = `Due Date must be within 3 months after the Lease End Date (${moment(linkedInv.lease_end_date).format(fieldDateFormat)})`;
				}
			}
			if (linkedInv?.due_date && !dueDate.isValid()) {
                validationInputs.due_date = "Please enter valid Due Date";
            }
            if (linkedInv?.date &&!invoiceDate.isValid()) {
                validationInputs.date = "Please enter valid Invoice Date";
            }
		}

		setError({ ...validationInputs });
		if (!Object.keys(validationInputs).every((k) => validationInputs[k] === '')) {
			trackActivity(`Item Added`, { page_title: 'Add ' + linkedInv?.invoice_type?.label, error_msg: validationInputs });
			return;
		}

		// ----------------Item Table Condition-----------
		let newErrors = {};
		let allZero = true;
		linkedInv.invoice_items.forEach((row, index) => {
			const errors = {};

			if (!titanAviationIntance && !row.description?.trim()) {
				errors.description = linkedInv?.parent_invoice_type === 6 ? "Please enter Security Against" : "Please enter Description";
			}

			const amount = Number(row.sub_total);


			if (row.sub_total === "" || row.sub_total === null || row.sub_total === undefined) {
				errors.sub_total = "Please enter Amount";
				allZero = false;
			}

			if (amount !== 0) {
				allZero = false;
			}

			if (linkedInv?.invoice_type?.label === "Credit Note") {
				if (amount > Number(row.original_amount)) {
					errors.sub_total = "Amount can't exceed Original Amount";
				}
			}

			if (Object.keys(errors).length > 0) {
				newErrors[index] = errors;
			}
		});

		setTableErrors(newErrors)

		if (allZero && linkedInv.invoice_items.length > 0) {
			enqueueSnackbar(
				"Please enter an amount greater than 0 for at least one Invoice Item's",
				{ variant: "error" }
			);
			return;
		}

		if (Object.keys(newErrors).length > 0) {
			return;
		}
		setLoading(true);
		const normalizedItems = linkedInv.invoice_items.map(item => {
			const subTotal = parseFloat(item.sub_total) || 0;
			if (subTotal === 0) {
				return { ...item, tax_rate: normalizeTaxRate(item.tax_rate), tax_amount: '0.0000', sub_amount_total: '0.0000' };
			}
			return { ...item, tax_rate: normalizeTaxRate(item.tax_rate) };
		});
		let updatedInvoiceItems = getAdditionalTax(normalizedItems, activeTaxList )
		let tax_details =  getTotalTax(linkedInv?.invoice_items, activeTaxList)
		globalPostService(addInvoiceApi(), {...linkedInv ,tax_details: tax_details, invoice_items: updatedInvoiceItems,  currency:linkedInv?.currency?.code, is_offset: true, footer_note : linkedInv?.bank?.footer_note || null,  })
			.then(async (response) => {
				if (checkApiStatus(response)) {
					if (attachments?.length) {
						dispatch(setUploadFiles({ modal: true, slug: response?.data?.data?.slug }));
					}
					setLoading(false);
					onToggleModal()
					// getResponseBack();
					trackActivity('Item Added', { page_title: 'Add ' + linkedInv?.invoice_type?.label, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: linkedInv, response: response?.data })
					navigate(`/invoices/view/${response?.data?.data?.slug}`,{ state: { from: from } })
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
				} else {
					setLoading(false);
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
					trackActivity('Item Added', { page_title: 'Add ' + linkedInv?.invoice_type?.label, error_msg: response?.data?.message, item_id: null, payload: linkedInv, response: response?.data })
				}
			})
	};

	const onFieldChange = useCallback((keyParam, value, invoiceItem, itemIndex) => {
        if (invoiceItem) {
            if (keyParam === "sub_total" || keyParam === "tax_rate") {
                setLinkedInv((prev) => {
                    const items = prev.invoice_items;
                    let subTotal = 0;
                    let taxAmount = 0;
                    if (keyParam === "sub_total") {
                        subTotal = parseFloat(value) || 0;
                        if (items[itemIndex].tax_rate) {
                            taxAmount = subTotal * (parseFloat(items[itemIndex].tax_rate) / 100);
                        }
                    } else {
                        subTotal = parseFloat(items[itemIndex].sub_total) || 0;
                        if (value) {
                            taxAmount = subTotal * (parseFloat(value) / 100);
                        }
                    }
                    const subAmountTotal = subTotal + taxAmount;
                    return {
                        ...prev,
                        invoice_items: items.map((item, index) =>
                            index !== itemIndex
                                ? item
                                : {
                                    ...item,
                                    [keyParam]: value,
                                    tax_amount: taxAmount.toFixed(4),
                                    sub_amount_total: subAmountTotal.toFixed(4),
                                }
                        ),
                    };
                });
            } else {
                setLinkedInv((prev) => ({
                    ...prev,
                    invoice_items: prev.invoice_items.map((item, index) =>
                        index !== itemIndex ? item : { ...item, [keyParam]: value }
                    ),
                }));
            }
        } else {
            setLinkedInv((prev) => ({ ...prev, [keyParam]: value }));
        }
    }, []);
	const handleFileChange = (files) => {
		setAttachments(files);
		dispatch(setFileUploadDetails({ attachments: files }))
	};

	const onRestErrorKey = (keyParam) => {
		setError({ ...error, [keyParam]: '' })
	}

	const resetTableError = (rowIndex, fieldName) => {
		setTableErrors((prevErrors) => {
			const rowErrors = { ...prevErrors[rowIndex] };
			delete rowErrors[fieldName];

			const updatedErrors = { ...prevErrors };
			if (Object.keys(rowErrors).length === 0) {
				delete updatedErrors[rowIndex];
			} else {
				updatedErrors[rowIndex] = rowErrors;
			}

			return updatedErrors;
		});
	};
	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: 'Add ' + linkedInv?.invoice_type?.label, page_type: page_type, })
	}
	return (
		<>
			<Dialog
				aria-labelledby="customized-dialog-title"
				className='add-lease-dialog'
				{...getInvoiceDialogWidthProps({ invoice: linkedInv, type: 'linkedInvoice', activeTaxList })}
				open={true}
			>
				<DialogTitle sx={{ m: 0, p: 2, pl:3 }} className='dialog-header' id="customized-dialog-title">
					Add {linkedInv?.invoice_type?.label ? linkedInv?.invoice_type?.label : null }
				</DialogTitle>
				<DialogContent dividers>
					<Grid container spacing={2}>
						<AInvbasicDetail leaseSlug={linkedInv?.lease_slug} addEditInvoice={item} type={'linkedInvoice'} parent_id={linkedInv?.parent_id} modeType={modeType} onFieldChange={onFieldChange} onRestErrorKey={onRestErrorKey} invoice={linkedInv} error={error} tableErrors={tableErrors} resetTableError={resetTableError} handleFileChange={handleFileChange} onActiveTaxLoad={setActiveTaxList}/>
					</Grid>
				</DialogContent>
				<DialogActions sx={{ marginRight: "15px" }}>
					<Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Cancel </Button>
					<Button variant='contained' className='btn-primary' size='small' onClick={() => { handleItemClicked('Save Button'); onAddEditInvoice(); }}>
						{isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
					</Button>
				</DialogActions>
			</Dialog>
			{(isLoading || invoiceNumberLoading) ? <PageLoader /> : null}
		</>
	)
}

export default AddLinkedInv